import React, { useState } from "react";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

const ItemTypes = {
  WORD: "word",
};

const DraggableWord = ({ word, index }) => {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: ItemTypes.WORD,
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }));

  return (
    <div
      ref={drag}
      className={`p-2 m-1 border rounded cursor-pointer ${
        isDragging ? "opacity-50" : "opacity-100"
      }`}
      style={{ backgroundColor: "lightblue" }}
    >
      {word}
    </div>
  );
};

const DroppablePlaceholder = ({ index, value, onDrop }) => {
  const [{ isOver }, drop] = useDrop(() => ({
    accept: ItemTypes.WORD,
    drop: (item) => onDrop(index, item.index),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  }));

  return (
    <input
      ref={drop}
      type="text"
      className={`inline-block w-24 h-8 border border-gray-400 px-2 text-sm rounded focus:outline-none focus:ring-1 focus:ring-blue-500 mx-1 ${
        isOver ? "bg-yellow-200" : ""
      }`}
      placeholder="?"
      value={value}
      readOnly
    />
  );
};

const FillMissingByDragDrop = ({
  questionNumber = "",
  answers = [],
  words = [],
  correctAnswers = [],
  onCalculateScore,
}) => {
  // Initialize state to store input values
  const [inputValues, setInputValues] = useState(
    answers.flatMap(sentence => sentence.split(/(_)/g)).filter(part => part === "_").map(() => "")
  );

  // Handle drop event
  const handleDrop = (placeholderIndex, wordIndex) => {
    setInputValues(prevValues => {
      const updatedValues = [...prevValues];
      updatedValues[placeholderIndex] = words[wordIndex];
      return updatedValues;
    });
  };

  let overallPlaceholderIndex = 0;

  return (
    <DndProvider backend={HTML5Backend}>
      <div className="p-3 w-full bg-white font-inter border border-gray-300 rounded-md shadow-md flex">
        {/* Full Paragraph with Inputs */}
        <div className="text-sm text-gray-800 whitespace-pre-line leading-relaxed flex-grow">
          {answers.map((sentence, sentenceIndex) => {
            const parts = sentence.split(/(_)/g);
            return (
              <div key={sentenceIndex}>
                {parts.map((part, index) => {
                  if (part === "_") {
                    const inputIndex = overallPlaceholderIndex++;
                    return (
                      <DroppablePlaceholder
                        key={index}
                        index={inputIndex}
                        value={inputValues[inputIndex]}
                        onDrop={handleDrop}
                      />
                    );
                  } else {
                    // Convert text inside < and > to bold
                    const formattedPart = part.replace(/<([^>]+)>/g, `<strong>$1</strong>`);
                    return (
                      <span key={index} dangerouslySetInnerHTML={{ __html: formattedPart }} />
                    );
                  }
                })}
              </div>
            );
          })}
        </div>

        {/* List of Words */}
        <div className="ml-4 flex flex-col">
          {words.map((word, index) => (
            <DraggableWord key={index} word={word} index={index} />
          ))}
        </div>
      </div>

      {/* Finish Button */}
      <div className="mt-4 flex justify-end">
        <button
          className="w-28 h-10 bg-blue-500 text-white rounded-md flex items-center justify-center cursor-pointer hover:bg-blue-600 transition text-lg"
          onClick={() => onCalculateScore(1, questionNumber, inputValues, correctAnswers)}
        >
          Finish
        </button>
      </div>
    </DndProvider>
  );
};

export default FillMissingByDragDrop;